import React, { useEffect, useState } from "react";

const LoopText = ({ items }) => {
  const [loopText, setLoopText] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const nextIndex = (currentIndex + 1) % items.length;
      const nextItem = items[nextIndex];

      setLoopText(nextItem);
      setCurrentIndex(nextIndex);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [currentIndex, items]);

  const isNullItem = loopText === null;

  return (
    <>
      <span className={`bc-blue-dark ${!isNullItem ? "loop-item" : ""}`}>
        {loopText}
      </span>
      <style jsx>{`
        .loop-item {
          padding: 0 8px;
        }
        @media (max-width: 650px) {
          .loop-item {
            padding: 0 4px;
          }
        }
      `}</style>
    </>
  );
};

export default LoopText;
